import { render, staticRenderFns } from "./AppGallery.vue?vue&type=template&id=467407d6"
import script from "./AppGallery.vue?vue&type=script&lang=js"
export * from "./AppGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports